// extracted by mini-css-extract-plugin
module.exports = {"pageLevelTabs":"PageLevelTabs_pageLevelTabs__I6t_s","pageLevelTabsOverflow":"PageLevelTabs_pageLevelTabsOverflow__VsOIC"};